import { Pipe, PipeTransform } from '@angular/core';
import { MissionRequest } from '../../models/mission/mission-request';

@Pipe({
	name: 'filterFormationBySkill'
})
export class FilterFormationBySkillPipe implements PipeTransform {
	transform(
		formations: MissionRequest[],
		filter: string | string[],
		centerType?
	): MissionRequest[] {
		if (
			formations === null ||
			!filter ||
			filter.length === 0 ||
			filter === ''
		) {
			return formations;
		}

		if (!Array.isArray(filter)) {
			filter = [filter];
		}

		const formationsFiltered = formations.filter((missionRequest) => {
			const missionCareSkills = missionRequest?.careSkills || [];
			const beneficiaireCareSkills =
				missionRequest?.beneficiaire?.careSkills || [];

			// Concatène les compétences de missionRequest et beneficiaire
			const allCareSkills = [...missionCareSkills, ...beneficiaireCareSkills];

			// Vérifie si l'une des compétences correspond à un des filtres
			for (const careSkill of allCareSkills) {
				for (const comp of filter) {
					if (careSkill.name.toLowerCase().includes(comp.toLowerCase())) {
						return true;
					}
				}
			}

			return false;
		});

		return formationsFiltered;
	}
}
